/* eslint-disable no-console */
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { downgradeToAJSComponent, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { IbCheckinApisDigitalDataService } from './services/ib-checkin-apis-digital-data.service';
import { IbUtilsService } from '@src/components/services/Utils/ib-utils.service';
import { CheckinAppConstants } from '@src/components/routing/ib-check-in-constants';
import { AJSModalService } from '@src/app/shared/services/ib-modal/ib-modal-service-bridge.service';
import {
    AlertAutoCheck,
    Button,
    ButtonProps,
    ModalTravelRequirements,
    ModalTravelRequirementsProps,
    PassengerCheckInUnavailableModal,
    PassengerCheckInUnavailableModalProps,
    PassengerDataCheckModal,
    PassengerDataCheckModalProps
} from 'commercial-management--digital--web-components-design--library';
import { TranslateService } from '@ngx-translate/core';
import { IbCheckinApisService } from './services/ib-checkin-apis.service';
import { ApisPassenger, EmitPassengerStatus, EventPassengerStatusChange, PassengersNOAPIS } from '@src/app/core/models/ib-checkin-apis/ib-checkin-apis.model';
import { ApisPassengerState } from '@src/app/core/constants/ib-checkin-apis-constants';
import { ElementType } from 'react';
import {
    OverlayStatus,
    CommonTranslationKeys,
    StatusOverlayProps
} from 'commercial-management--digital--web-components-design--library/dist/components/layout/status-overlay/StatusOverlay';
import { AcceptService } from './services/ib-call-accept.service';

@Component({
    selector: 'ib-checkin-apis',
    templateUrl: './ib-checkin-apis.component.html',
    styleUrls: ['./ib-checkin-apis.component.scss']
})
export class IbCheckinApisComponent implements OnInit, AfterViewInit {
    protected readonly ButtonContinue: ElementType = Button;
    protected readonly AlertAutoCheck: ElementType = AlertAutoCheck;
    protected readonly ModalTravelRequirements: ElementType = ModalTravelRequirements;
    private continueAllowed: boolean = false;
    passengerCheckInUnavailableModal: ElementType = PassengerCheckInUnavailableModal;
    passengerDataCheckModal: ElementType = PassengerDataCheckModal;
    buttonContinueProps: ButtonProps;
    modalTravelRequirementsProps: ModalTravelRequirementsProps = {
        requiredFields: []
    };
    passengers: ApisPassenger[] = [];
    passengersNOAPIS: PassengersNOAPIS[] = [];
    openAccordionIndex: number = 0;
    showAlertInfo: boolean = false;
    passengersIdCompleted: number[] = [];
    messageKey: CommonTranslationKeys = 'DATA_BEING_VALIDATED';
    requiredFields: string[] = [];
    openModal: boolean = false;
    showModalTravel: boolean = false;
    countPassengers = { all: 0, isSingle: false, isMulti: false };

    dataCheckModalProps: PassengerDataCheckModalProps = {
        open: false,
        onClose: () => {
            this.openPassengerDataCheckModal();
        },
        onPrimaryAction: () => {
            this.continueFlow();
        }
    };

    isUnavailableModalOpen: boolean = false;
    unavailableModalProps: PassengerCheckInUnavailableModalProps = {
        open: this.isUnavailableModalOpen,
        onPrimaryAction: () => {
            this.handleUnavailableCheckin();
        },
        buttonText: 'single'
    };
    overlayProps: StatusOverlayProps = {
        status: 'loading',
        messageKey: 'DATA_BEING_VALIDATED',
        isOpen: false
    };
    isMultiPassengers: boolean;

    constructor (
        @Inject(AJSModalService) private CheckinModalService,
        private IbCheckinApisService: IbCheckinApisService,
        private IbCheckinApisDigitalDataService: IbCheckinApisDigitalDataService,
        private IbUtilsService: IbUtilsService,
        private TranslateService: TranslateService,
        private AcceptService: AcceptService,
        private CommonsSessionStorageService: CommonsSessionStorageService
    ) {}

    async ngOnInit (): Promise<void> {
        try {
            this.CheckinModalService.isWaiting();
            this.IbUtilsService.setTitlePage(CheckinAppConstants.TITLE_PAGE.APIS_PASSENGERS, 1400);
            await this.getDataPassengers();
            this.getButtonContinueProps(this.passengersIdCompleted.length > 0);
            this.showAlertInfo = this.countPassengers.isMulti;
            this.extractRequiredFieldsFromPassengers(this.passengers);
            this.modalTravelRequirementsProps = { ...this.modalTravelRequirementsProps, requiredFields: this.requiredFields };
            this.CheckinModalService.finishWaiting();
            this.showModalTravel = true;
        } catch (error) {
            console.log(error);
        } finally {
            this.CheckinModalService.isNotWaiting();
        }
    }

    ngAfterViewInit (): void {
        this.IbCheckinApisDigitalDataService.emitViewEvent();
    }

    async getDataPassengers () {
        this.IbCheckinApisDigitalDataService.setApisDigitalData();
        this.passengers = await this.IbCheckinApisService.getApisInfo();
        this.passengersNOAPIS = this.getPassengersNOAPI();
        this.countPassengers.all = this.passengers.length + this.passengersNOAPIS.length;
        this.countPassengers.isSingle = this.countPassengers.all === 1;
        this.countPassengers.isMulti = this.countPassengers.all > 1;
    }

    getButtonContinueProps (continueAllowed: boolean = false) {
        const isMobile = window.innerWidth <= 767;
        this.buttonContinueProps = {
            variant: continueAllowed ? 'primary' : 'gray',
            bordered: !continueAllowed,
            disabled: !continueAllowed,
            full: isMobile,
            children: this.TranslateService.instant('Continuar con Check-in'),
            //testId: 'button-continue-flow',
            onClick: () => this.onClickButtonContinue()
        };
    }

    passengerStatusChange ({ status, id, index }: EventPassengerStatusChange) {
        this.passengers.map((passenger) => {
            if (passenger.id === id.toString()) passenger.formStatus = status;
        });

        if (status === ApisPassengerState.COMPLETED) {
            this.passengersIdCompleted.push(id);
            this.IbCheckinApisDigitalDataService.updateApisDigitalData();
            if (!this.continueAllowed && this.countPassengers.isMulti && index < this.passengers.length - 1) {
                this.openAccordionIndex = index + 1;
            }

            if (this.countPassengers.isMulti) {
                this.CheckinModalService.isNotWaiting();
                this.getButtonContinueProps(true);
            } else {
                this.continueFlow();
            }
        }
    }

    toggleAccordion (index: number) {
        this.openAccordionIndex = this.openAccordionIndex === index ? -1 : index;
    }

    formatName = (name?: string, surname?: string) => (name && surname ? `${name} ${surname}` : '');

    getFullNameInfant (fullName: string, infantFullName: string) {
        return this.IbUtilsService.isResolutionToMobile() ? `${fullName} ${infantFullName}` : `${fullName} + ${infantFullName}`;
    }

    getFullName (passenger: ApisPassenger) {
        const { name, surname, infant } = passenger.passengerBookingInfo;
        const fullName = this.formatName(name, surname);
        const infantFullName = infant ? this.formatName(infant.name, infant.surname) : '';
        const resultFullName = infantFullName ? this.getFullNameInfant(fullName, infantFullName) : fullName;
        return resultFullName.toLowerCase();
    }

    onClickButtonContinue (): void {
        const areSomePassengersCompleted = this.passengersIdCompleted.length > 0 && this.passengersIdCompleted.length < this.countPassengers.all;
        const areAllPassengersCompleted = this.passengersIdCompleted.length === this.countPassengers.all;
        const isMultiSomeCompleted = this.countPassengers.isMulti && areSomePassengersCompleted;
        const isMultiAllCompleted = this.countPassengers.isMulti && areAllPassengersCompleted;
        const isSingleAllCompleted = this.countPassengers.isSingle && areAllPassengersCompleted;

        if (isMultiSomeCompleted) {
            this.CheckinModalService.isNotWaiting();
            this.openPassengerDataCheckModal(true);
        } else if (isMultiAllCompleted || isSingleAllCompleted) {
            this.continueFlow();
        }
    }

    private openPassengerDataCheckModal (isOpen: boolean = false): void {
        this.dataCheckModalProps = {
            ...this.dataCheckModalProps,
            open: isOpen
        };
    }

    handleUnavailableCheckin (): void {
        const { allDocs, someDocs } = this.getPassengerStatus();
        const isSingleOrMulti = this.countPassengers.isSingle || this.countPassengers.isMulti;

        if (someDocs) {
            this.closeUnavailableModal();
        } else if (allDocs && isSingleOrMulti) {
            this.redirectToCheckin('/ibcoac');
        }
    }

    private getDocumentedPassengers (): ApisPassenger[] {
        return this.passengers.filter((p) => p.formStatus === ApisPassengerState.DOCUMENTATION) || [];
    }

    private getPassengerStatus (): {
        allDocs: boolean;
        someDocs: boolean;
    } {
        const docsPassengers = this.getDocumentedPassengers();
        const allDocs = docsPassengers.length === this.countPassengers.all;
        const someDocs = docsPassengers.length > 0 && !allDocs;
        return { allDocs, someDocs };
    }

    private closeUnavailableModal (): void {
        this.isUnavailableModalOpen = false;
        this.unavailableModalProps = { ...this.unavailableModalProps, open: false };
    }

    private redirectToCheckin (path: string): void {
        this.IbCheckinApisService.redirectToCheckin(path);
    }

    private continueFlow (): void {
        this.openPassengerDataCheckModal();
        this.CheckinModalService.isWaiting();
        const passengersSelected = this.IbUtilsService.updatePassengersSelected(this.passengersIdCompleted);
        this.AcceptService.callAccept(passengersSelected, false, null, null);
    }

    updateOverlayStatus (passengerStatus: ApisPassengerState) {
        const overlayState = {
            [ApisPassengerState.PENDING]: { isOpen: true, status: 'loading', messageKey: 'DATA_BEING_VALIDATED' },
            [ApisPassengerState.COMPLETED]: { isOpen: true, status: 'success', messageKey: 'DATA_VALIDATED_AND_SAVED' },
            [ApisPassengerState.CLOSE]: { isOpen: false }
        };

        const newStatus = overlayState[passengerStatus] || { isOpen: false };

        if (passengerStatus === ApisPassengerState.CLOSE) {
            setTimeout(() => {
                this.overlayProps.isOpen = newStatus.isOpen;
            }, 1000);
        } else {
            if (newStatus.isOpen) {
                this.overlayProps.status = newStatus.status;
                this.overlayProps.messageKey = newStatus.messageKey;
            }
            this.overlayProps.isOpen = newStatus.isOpen;
        }
    }

    extractRequiredFieldsFromPassengers (passengers: ApisPassenger[]) {
        const requiredFields = passengers?.flatMap((passenger) => {
            const passengerFields = passenger.requiredFields || [];
            const documentCodes = passenger.mandatoryDocuments?.flatMap((mandatoryDocument) => mandatoryDocument.documents.flatMap((document) => document.type?.code || [])) || [];
            return [...passengerFields, ...documentCodes];
        });
        this.isMultiPassengers = passengers.length > 1;
        this.requiredFields = Array.from(new Set(requiredFields));

        this.modalTravelRequirementsProps = { ...this.modalTravelRequirementsProps, requiredFields: this.requiredFields };
        this.showModalTravel = true;
    }

    showModalCheckinNotAvailable (passenger: EmitPassengerStatus) {
        if (passenger.status === ApisPassengerState.DOCUMENTATION && this.countPassengers.all > 0) {
            const { someDocs } = this.getPassengerStatus();
            let buttonText: 'single' | 'multiple' = 'single';
            this.isUnavailableModalOpen = true;

            if(this.countPassengers.isMulti && someDocs) {
                buttonText = 'multiple';
            }

            this.updateApisPassengersDocumentation(passenger.id);

            this.unavailableModalProps = {
                ...this.unavailableModalProps,
                open: this.isUnavailableModalOpen,
                buttonText: buttonText,
                fullName: passenger.fullName,
                showMessage: passenger.showMessage || false,
                message: passenger.message || ''
            };
        }
    }

    private updateApisPassengersDocumentation (passengerId: number) {
        const passengersDoc: number[] = this.CommonsSessionStorageService.get(CheckinAppConstants.STORAGE_KEYS.PASSENGERS_APIS_DOCS) || [];
        const newPassengersDoc: number[] = [passengerId];
        const allPassengersDoc = Array.from(new Set([...passengersDoc, ...newPassengersDoc]));
        this.CommonsSessionStorageService.set(CheckinAppConstants.STORAGE_KEYS.PASSENGERS_APIS_DOCS, allPassengersDoc);
    }

    private getPassengersNOAPI (): PassengersNOAPIS[] {
        const passengersNOAPIS: any[] = this.CommonsSessionStorageService.get(CheckinAppConstants.STORAGE_KEYS.PASSENGERS_NOAPIS) || [];
        const bookingInfo: any = this.CommonsSessionStorageService.get(CheckinAppConstants.STORAGE_KEYS.BOOKING_INFO);
        const result: PassengersNOAPIS[] = [];

        passengersNOAPIS.forEach((passengerId) => {
            const passengerData = bookingInfo?.passengers.find((passenger) => passenger.id === passengerId);
            if (passengerData) {
                result.push({
                    id: passengerData.id,
                    status: ApisPassengerState.COMPLETED,
                    fullName: this.formatName(passengerData.name, passengerData.surname),
                    isNOAPI: true
                });
                // init passengers completed
                this.passengersIdCompleted.push(passengerId);
            }
        });

        return result;
    }
}

downgradeToAJSComponent(
    'ibCheckinApis',
    {
        component: IbCheckinApisComponent
    },
    'ib-check-in-apis-module',
    []
);
